export default __webpack_public_path__ + "568c45749574352781ea764e8902abb5.jpg";